module.exports = __webpack_public_path__ + "img/usersSettings.0feade6e.jpg";